module.exports = __webpack_public_path__ + "f6c92677cfc2da529954fb62e218fb5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques2/02.jpg
// module id = D1Kt
// module chunks = 0